import {Component, OnInit} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {UtilsService} from '../../core/services/utils/utils.service';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css'],
    standalone: false
})

export class UsersComponent implements OnInit {

  users: any = {users: [], currentPage: 1, totalItems: 0};
  loading = true;
  loaders = Array(10).fill(0);
  page = 1;
  perPage = 10;
  filters = {
    keyword: '',
    type: 'all',
    approved: 'all',
    status: 'all',
    sortBy: 'created_desc'
  };

  constructor(
    private dashboardService: DashboardService,
    private utils: UtilsService,
  ) {
  }

  ngOnInit(): void {
    this.readAllUsers();
  }

  buildUsersQuery(page: number = 1): any {
    const query: any = {
      page,
      per_page: this.perPage,
      sort_by: this.filters.sortBy
    };

    const keyword = (this.filters.keyword || '').trim();
    if (keyword) {
      query.keyword = keyword;
    }

    if (this.filters.type !== 'all') {
      query.type = this.filters.type;
    }

    if (this.filters.approved !== 'all') {
      query.approved = this.filters.approved;
    }

    if (this.filters.status !== 'all') {
      query.status = this.filters.status;
    }

    return query;
  }

  readAllUsers(newPage: number = this.page): void {
    this.page = newPage;
    this.loading = true;
    this.dashboardService.readAllUsers(this.buildUsersQuery(newPage)).subscribe(res => {
      this.users = res.response || res;
      this.loading = false;
    }, (err => {
      this.utils.resErr(err);
      this.loading = false;
    }));
  }

  remove(user): void {
    const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || user?.email || 'this user';
    if (!confirm(`Are you sure you want to delete ${fullName}?`)) {
      return;
    }

    this.dashboardService.deleteUserById(user.id).subscribe(res => {
      this.utils.toastSuccess('User deleted successfully');
      this.readAllUsers(this.page);
    }, err => {
      this.utils.resErr(err);
    });
  }

  pageChange(event): void {
    this.page = event;
    this.readAllUsers(event);
  }

  handleCopyToClipboard(str: any = ''): void {
    this.utils.copyToClipboard(str);
    this.utils.toastSuccess('ID copied to your clipboard successfully');
  }

  approveUser(id: any = ''): void {
    this.dashboardService.approveUser(id, {approvedByAdmin: true}).subscribe(res => {
      this.readAllUsers(this.page);
    }, (err => {
      this.utils.resErr(err);
    }));
  }

  activateUser(id: any = ''): void {
    this.dashboardService.approveUser(id, {status: 'active'}).subscribe(res => {
      this.readAllUsers(this.page);
    }, (err => {
      this.utils.resErr(err);
    }));
  }

  enableClaim(user: any): void {
    const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim()
      || user?.email
      || 'this user';

    if (!confirm(`Enable profile claiming for ${fullName}?`)) {
      return;
    }

    this.dashboardService.updateUser(user.id, {profile_claim: false}).subscribe(() => {
      this.utils.toastSuccess('Profile claiming enabled successfully');
      this.readAllUsers(this.page);
    }, err => {
      this.utils.resErr(err);
    });
  }

  applyFilters(): void {
    this.readAllUsers(1);
  }

  clearFilters(): void {
    this.filters = {
      keyword: '',
      type: 'all',
      approved: 'all',
      status: 'all',
      sortBy: 'created_desc'
    };
    this.readAllUsers(1);
  }

  hasActiveFilters(): boolean {
    return !!(this.filters.keyword || '').trim()
      || this.filters.type !== 'all'
      || this.filters.approved !== 'all'
      || this.filters.status !== 'all'
      || this.filters.sortBy !== 'created_desc';
  }

  handleFilterInputKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.applyFilters();
    }
  }
}
